import React from 'react';
import { connect } from 'react-redux';
import { updateServiceFee } from '../../actions';
import { ownerFeeServiceFeeCellHTML } from './owner-service-fee-cell';

// Create an editable cell renderer
const RenterServiceFeeCell = ({
  cell: { value: initialValue },
  data: user,
  dispatch
}) => {
  // We need to keep and update the state of the cell normally
  const [value, setValue] = React.useState(initialValue);
  const [cellEditable, setCellEditable] = React.useState(false);

  function buttonClicked() {
    let service = value;
    if (service > 1) {
      service = 1;
    } else if (service < 0) {
      service = 0;
    }
    user.serviceFees.renterFee = service;
    dispatch(updateServiceFee(user.serviceFees, user._id));
    setCellEditable(false);
  }

  // If the initialValue is changed externall, sync it up with our state
  React.useEffect(() => {
    setValue(initialValue)
  }, [initialValue])

  if (user.userType === "admin") {
    return (<div />);
  }

  return ownerFeeServiceFeeCellHTML(value, setValue, buttonClicked, cellEditable, setCellEditable);
}
export default connect()(RenterServiceFeeCell);
